<div class="card">

    <div class="card-body">
        <h5 class="card-title">Detalle del pedido</h5>
        <div class="row">

            <div class="col-4 ">
                <div class="border border-dark rounded p-2 h-100">
                    <div>
                        <span class="font-weight-bold"> {{pedidoDetall.cliNombre}} </span>
                        <br>
                        Pedido: <span class="text-info font-weight-bold"> {{pedidoDetall.pedido_cli}} </span>
                        <span [innerHTML]=" pedidoDetall.estado | pedidoEstado "> </span>
                        <span class="font-italic text-muted text-sm"> {{ pedidoDetall.estado_at | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                    </div>
                    <div class="mb-2">
                        <span class="d-block">
                            Tipo: <span class="text-info">{{pedidoDetall.tipoPedido}}</span> -
                            Servicio: <span class="text-info">{{pedidoDetall.cod_servicio}}</span> <span class="text-secondary"><small> ({{pedidoDetall.servicio?.nombre}})</small></span><br>
                            Referencia: <span class="text-info">{{pedidoDetall.ref_envio}}</span>
                        </span>
                    </div>

                </div>
            </div>

            <div class="col-4 ">
                <div class="border border-dark rounded p-2 h-100">

                    <div class="row">
                        <div class="col-8">
                            <h4 class="card-title">Destinatario</h4>
                            <h6 class="card-subtitle">
                                <span class="text-info"> {{pedidoDetall.nombre}}</span>
                                <span *ngIf="pedidoDetall.contrarrembolso && pedidoDetall.contrarrembolso > 0"
                                      class="text-danger font-italic text-sm"><br>
                                    (contrarrembolso de {{ pedidoDetall.contrarrembolso | number: '0.0-0':'es'}} €)
                                </span>
                                <br>
                                {{pedidoDetall.direccion}} <br>
                                {{pedidoDetall.cp}} - {{pedidoDetall.poblacion}} <br>
                                {{pedidoDetall.provincia}} - {{pedidoDetall.pais_iso}}
                            </h6>
                        </div>

                        <div class="col-4">
                            <h4 class="card-title">Preparación</h4>
                            <ul [class]="((pedidoDetall.repartosList || [] | unico:'uic').length || 0) > 5 ? 'lista-con-scroll' : 'list-unstyled'">
                                <li *ngFor="let reparto of (pedidoDetall.repartosList || [] | unico:'uic')"
                                    title="INFORMACIÓN de este UIC">
                                    <a [routerLink]="'/panel/uic-info/' + reparto.uic"
                                       class="link">
                                        <code class="text-dark">{{reparto.uic}}</code>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>


                </div>
            </div>


            <div class="col-4 ">
                <div class="border border-dark rounded p-2 h-100">

                    <div class="row">

                        <div class="col-8">
                            <h4 class="card-title">Estados del pedido</h4>
                            <ul>
                                <li *ngFor="let estado of pedidoDetall.estadosList">
                                    <span [innerHTML]=" estado.estado | pedidoEstado "> </span>
                                    <span class="font-italic text-muted text-sm"> {{ estado.estado_at | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                                </li>
                            </ul>
                        </div>

                        <div class="col-4">
                            <h4 class="card-title">Complemetarios</h4>
                            <span *ngFor="let comp of pedidoDetall.complementariosList"
                                  class="d-block">
                                <a [routerLink]="['/panel/pedidos_lista', comp.id]"
                                   target="_blank"
                                   class="link">
                                    <small title="{{comp.created_at | date:'dd/MM/yyyy HH:mm' }}"> {{comp.pedido_cli }}</small>
                                </a>
                            </span>
                        </div>

                    </div><!-- row -->
                </div>

            </div>
        </div><!-- row -->

        <div class="bootstrap-table mt-1">

            <div>
                <table class="table table-sm table-striped table-bordered table-hover">

                    <thead>
                        <tr>
                            <th></th>
                            <th *ngFor="let col of colArticulosLabel"
                                (click)="ordenarArticulosCol(col.key)"
                                style="cursor: pointer"
                                [ngStyle]="col.style || {}">
                                <i *ngIf="col.key === 'artEan'"
                                   class="fa fa-barcode"></i> {{ col.label }}
                                <span *ngIf="sortColumnArt === col.key">
                                    <i class="text-success"
                                       [ngClass]="sortDirectionArt === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'">
                                    </i>
                                </span>
                            </th>
                            <th>Acciones</th>
                        </tr>
                    </thead>

                    <!-- Si hay detall y no está ubicado, mostrarlo -->
                    <tbody>
                        <ng-container *ngFor="let detall of pedidoDetall.detall; let i = index">

                            <tr [ngClass]="{'infoSelectRow': detall?.id_articulo == articData?.id_articulo}">
                                <td>
                                    <img [src]="fotoDir +'/articulos' + imgResized + detall.artFoto"
                                         loading="lazy"
                                         alt="Foto"
                                         class="rounded pointer border"
                                         height="25px"
                                         (click)="abrirPopupImagen(fotoDir + '/articulos' + '/' + detall.artFoto)">

                                </td>
                                <td>{{ detall.artSku }}</td>
                                <td [ngClass]="{'resaltado': detall.artEan === eanSeleccionado}">{{ detall.artEan }}</td>
                                <td>{{ detall.artDescripcion }}</td>

                                <td style="text-align: right; padding-left: 10px">
                                    <div class="pl-25 mr-20 monospace">
                                        {{ detall.cantidad | number: '0.0-0':'es'}}
                                    </div>
                                </td>

                                <td style="text-align: right; padding-left: 10px">
                                    <div class="pl-25 pr-2 mr-20 monospace"
                                         [ngClass]="{'bg-warning': (detall.cantidad != detall.cant_repartida)}">
                                        {{ detall.cant_repartir | number: '0.0-0':'es'}}
                                    </div>
                                </td>

                                <td style="text-align: right; padding-left: 10px">
                                    <div class="pl-25 pr-2 mr-20 monospace"
                                         [ngClass]="{
                                            'bg-green': (detall.cant_repartir == detall.cant_repartida) && detall.cant_repartida! > 0,
                                            'bg-blue': (detall.cant_repartida! < detall.cant_repartir!) && detall.cant_repartida! > 0
                                         }">
                                        {{ detall.cant_repartida | number: '0.0-0':'es'}}
                                    </div>
                                </td>


                                <td>
                                    <a (click)="( detall.cant_repartida! > 0) ? infoArticuloPedido(detall) : null"
                                       class="link mr-1 pointer"
                                       title="INFORMACIÓN de cajas para este artículo"
                                       [ngClass]="{'disabled':( detall.cant_repartida! < 1) }">
                                        <span class="acciones-badge"
                                              [ngClass]="{'infoSelect': detall?.id_articulo == articData?.id_articulo}">
                                            I
                                        </span>
                                    </a>

                                    <a (click)="eanLabelsSrv.imprimirEanLabel(detall.id_articulo!)"
                                       class="link mr-1 pointer"
                                       title="Generar etiquetas EAN">
                                        <span class="acciones-badge">E</span>
                                    </a>
                                </td>


                            </tr>
                        </ng-container>
                    </tbody>


                    <tfoot>
                        <tr>
                            <td style="text-align: left"
                                colspan="2">Total:</td>
                            <td style="text-align: right; padding-left: 10px">
                                <div class="pl-25 mr-20 monospace"
                                     [class.text-danger]="pedidoDetall.tot_referencias! < 1">
                                    {{ pedidoDetall.tot_referencias | number: '0.0-0':'es' }}
                                </div>
                            </td>

                            <td></td>
                            <td style="text-align: right; padding-left: 10px">
                                <div class="pl-25 mr-20 monospace">
                                    {{ pedidoDetall.tot_articulos | number: '0.0-0':'es' }}
                                </div>
                            </td>
                            <td style="text-align: right; padding-left: 10px">
                                <div class="pl-25 mr-20 monospace">
                                    {{ pedidoDetall.tot_cant_repartir | number: '0.0-0':'es' }}
                                </div>
                            </td>
                            <td style="text-align: right; padding-left: 10px">
                                <div class="pl-25 mr-20 monospace pr-2">
                                    {{ pedidoDetall.tot_cant_repartida | number: '0.0-0':'es' }}
                                </div>
                            </td>
                        </tr>
                    </tfoot>


                </table>
            </div>



        </div>
    </div>

    <div class="clearfix"></div>
</div>




<!--  Detalle del artículo en el pedido -->
<div *ngIf="hasArticuloDetall()"
     class="card">
    <div class="card-body">


        <div class="row">

            <div class="col-4 ">
                <h5>Detalle del artículo en el pedido</h5>
                <div class="border border-dark rounded p-2">
                    <div class="row">

                        <div class="col-8">
                            <div class="text-info">
                                <span class="font-weight-bold">{{articData.artEan}} - {{articData.artSku}}</span>
                            </div>

                            <h6 class="card-subtitle">{{articData.artDescripcion}}</h6>

                            <div class="row">
                                <div class="col-6">
                                    <span class="font-weight-bold">Stock:</span> {{stockData.stock}}
                                </div>
                                <div class="col-6">
                                    <span class="font-weight-bold">Reservas:</span> {{stockData.reservas}}
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <img [src]="fotoDir +'/articulos' + imgResized + articData.artFoto"
                                 loading="lazy"
                                 alt="Foto"
                                 class="rounded pointer border"
                                 height="100px"
                                 (click)="abrirPopupImagen(fotoDir + '/articulos' + '/' + articData.artFoto)">
                        </div>

                    </div> <!-- row -->



                </div>
            </div>

        </div> <!-- row -->

        <div class="bootstrap-table">

            <div>
                <table class="table table-sm table-striped table-bordered table-hover">

                    <thead>
                        <tr>
                            <th>Caja</th>
                            <th>UIC</th>
                            <th style="text-align: center; padding-left: 10px; white-space: nowrap; width: 1px;">Cantidad</th>
                        </tr>
                    </thead>

                    <tbody>
                        <ng-container *ngFor="let detall of articuloDetall; let i = index">

                            <tr>
                                <td>{{ detall.caja_num }}</td>
                                <td>{{ detall.caja_uic }}</td>

                                <td style="text-align: right; padding-left: 10px">
                                    <div class="pl-25 mr-20 monospace">
                                        {{ detall.cantidad | number: '0.0-0':'es'}}
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>

                    <tfoot>
                        <tr>
                            <td style="text-align: left">Total:</td>
                            <td style="text-align: right; padding-left: 10px">
                                <div *ngIf="contaCajas > 1"
                                     class="pl-25 mr-20 monospace">
                                    {{ contaCajas | number: '0.0-0':'es' }} cajas
                                </div>
                            </td>
                            <td>
                                <div class="pl-25 mr-20 monospace font-weight-bold">
                                    {{ sumaCantidad | number: '0.0-0':'es' }}
                                </div>
                            </td>
                        </tr>
                    </tfoot>

                </table>
            </div>



        </div>
    </div>

    <div class="clearfix"></div>
</div>



<!-- Modal para mostrar la imagen -->
<div class="modal-overlay"
     *ngIf="imagenSeleccionada"
     (click)="cerrarPopupImagen()">
    <div class="modal-content">
        <img [src]="imagenSeleccionada"
             class="modal-image"
             alt="Imagen seleccionada">
    </div>
</div>